// Test IDs for Phase 6.2 account lifecycle + legal + password reset.
export const ACCOUNT = {
        area: 'account-area',
        onboarding: 'onboarding-welcome',
        onboardingDismiss: 'onboarding-dismiss',
        card: 'account-card',
        displayNameInput: 'account-display-name-input',
        saveButton: 'account-save-button',
        logoutButton: 'account-logout-button',
        deleteButton: 'account-delete-button',
        deleteConfirmButton: 'account-delete-confirm-button',
        deleteCancelButton: 'account-delete-cancel-button',
        betaReaccept: 'legal-beta-reaccept',
        betaReacceptButton: 'legal-beta-reaccept-button',
        contributorTerms: 'legal-contributor-terms',
        contributorTermsButton: 'legal-contributor-terms-button',
        editButton: 'account-edit-button',
        editCancel: 'account-edit-cancel',
        emailInput: 'account-email-input',
        emailChangeButton: 'account-email-change-button',
        emailSent: 'account-email-sent',
};

export const RESET = {
        page: 'reset-password-page',
        emailInput: 'reset-email-input',
        requestButton: 'reset-request-button',
        requestDone: 'reset-request-done',
        newPasswordInput: 'reset-new-password-input',
        newPasswordConfirmInput: 'reset-new-password-confirm-input',
        confirmButton: 'reset-confirm-button',
        confirmDone: 'reset-confirm-done',
        loginButton: 'reset-login-button',
        invalid: 'reset-invalid',
};
